import { useState } from 'react';

import { authAsyncActions } from 'configs';
import { COMMON_COL_PROPS, ROW_GUTTER } from 'consts';
import { useDispatch, useSelector } from 'hooks';
import { Client } from 'types';

import {
  Button,
  Col,
  Form,
  FormattedMessage,
  Icons,
  InputEmail,
  InputText,
  Row,
  SubmitButton,
} from 'components';

import { ChangePasswordModal } from './components';

const Summary = () => {
  const { client, loading, mobile } = useSelector((state) => ({
    client: state.auth.client as Client,
    loading: state.auth.loading,
    mobile: state.appState.breakpoint.mobile,
  }));
  const dispatch = useDispatch();
  const [modalVisible, toggleModal] = useState(false);

  return (
    <>
      <ChangePasswordModal
        open={modalVisible}
        onCancel={() => {
          toggleModal(false);
        }}
      />
      <Form
        name='summary'
        layout='vertical'
        initialValues={client}
        onFinish={(values) => {
          dispatch(
            authAsyncActions.updateClient({
              id: client.id,
              ...values,
            }),
          );
        }}
      >
        <Row gutter={ROW_GUTTER}>
          <Col {...COMMON_COL_PROPS}>
            <Row gutter={[8, 8]}>
              <Col xs={24} sm={12}>
                <InputText
                  required
                  label='common.first_name'
                  name='firstName'
                />
              </Col>
              <Col xs={24} sm={12}>
                <InputText required label='common.last_name' name='lastName' />
              </Col>
            </Row>
          </Col>
          <Col {...COMMON_COL_PROPS}>
            <InputEmail label='common.emailAddress' disabled />
            <Row justify={mobile ? 'center' : 'start'}>
              <Form.Item
                label={<FormattedMessage id='button.changePassword' />}
              >
                <Row justify={mobile ? 'center' : 'start'}>
                  <Button
                    icon={<Icons.ApiOutlined />}
                    onClick={() => {
                      toggleModal(true);
                    }}
                  />
                </Row>
              </Form.Item>
            </Row>
          </Col>
        </Row>
        <SubmitButton loading={loading} />
      </Form>
    </>
  );
};

export default Summary;
